import script from "./admin_ageSession.vue?vue&type=script&setup=true&lang=js"
export * from "./admin_ageSession.vue?vue&type=script&setup=true&lang=js"

import "./admin_ageSession.vue?vue&type=style&index=0&id=88f782f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88f782f2"]])

export default __exports__